var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStairsOutdoorFloor2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 223.84004,
    height: 115.20001,
    viewBox: "0 0 223.84003 115.20001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1096"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1311,0 H 3413 V 6212 H 1311 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path1096"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer-oc1",
    transform: "translate(-720.90672,-414.82667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1078",
    d: "m 2202,2062 v -434 h -625 v 434 h 625",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1079",
    d: "M 1890,1628 V 838 h 16 v 790 h -16",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1080",
    d: "m 1906,838 v 79 h 296 v -79 h -296",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1081",
    d: "m 1906,917 v 79 h 296 v -79 h -296",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1082",
    d: "m 1906,996 v 79 h 296 v -79 h -296",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1083",
    d: "m 1906,1075 v 79 h 296 v -79 h -296",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1084",
    d: "m 1906,1154 v 79 h 296 v -79 h -296",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1085",
    d: "m 1906,1233 v 79 h 296 v -79 h -296",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1086",
    d: "m 1906,1312 v 79 h 296 v -79 h -296",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1087",
    d: "m 1906,1391 v 79 h 296 v -79 h -296",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1088",
    d: "m 1906,1470 v 79 h 296 v -79 h -296",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1089",
    d: "m 1906,1549 v 79 h 296 v -79 h -296",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1090",
    d: "M 1890,1628 V 838 h -16 v 790 h 16",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1091",
    d: "m 1874,1391 v 79 h -297 v -79 h 297",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1092",
    d: "m 1874,1470 v 79 h -297 v -79 h 297",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1093",
    d: "m 1874,1549 v 79 h -297 v -79 h 297",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1094",
    d: "M 2054,838 V 1862 H 1726",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1095",
    d: "m 1740,791 -14,-31 v 20 z m -14,-31 v 20 l -15,11 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath1096)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1097",
    d: "M 1726,1862 V 780",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1098",
    d: "m 1726,780 -15,11 15,-31 14,31 -14,-11",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1099",
    d: "m 1577,1312 v 79 h 297 v -79 h -297",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1100",
    d: "m 1577,1233 v 79 h 297 v -79 h -297",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1101",
    d: "m 1577,1154 v 79 h 297 v -79 h -297",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1102",
    d: "m 1577,1075 v 79 h 297 v -79 h -297",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1103",
    d: "m 1577,996 v 79 h 297 v -79 h -297",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1104",
    d: "m 1577,917 v 79 h 297 v -79 h -297",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1105",
    d: "m 1577,838 v 79 h 297 v -79 h -297",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1106",
    d: "m 1577,760 v 78 h 297 v -78 h -297",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1107",
    d: "m 2202,2062 v 46 h 44 v -46 h -44",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1108",
    d: "m 1577,2062 v 45 h -44 v -45 h 44",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1109",
    d: "m 1577,760 v -45 h -45 v 45 h 45",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1110",
    d: "m 2244,760 v -45 h -45 v 45 h 45",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1118",
    d: "M 2202,2062 V 760 h 20 v 1302 h -20",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1119",
    d: "M 1558,2062 V 760 h 19 v 1302 h -19",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1120",
    d: "m 2202,2062 v 23 h -625 v -23 h 625",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStairsOutdoorFloor2);
export default __webpack_public_path__ + "static/media/stairs_outdoor_floor2.f204bc4e8f00eefd2159d98e4573f71f.svg";
export { ForwardRef as ReactComponent };